
    export default {
        props: {
            text: {
                type: String,
                default: "Description Text",
                required: true
            }
        }
    }

